/**
 * @file popup-button.js
 */
'use strict';

exports.__esModule = true;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _clickableComponentJs = require('../clickable-component.js');

var _clickableComponentJs2 = _interopRequireDefault(_clickableComponentJs);

var _componentJs = require('../component.js');

var _componentJs2 = _interopRequireDefault(_componentJs);

var _popupJs = require('./popup.js');

var _popupJs2 = _interopRequireDefault(_popupJs);

var _utilsDomJs = require('../utils/dom.js');

var Dom = _interopRequireWildcard(_utilsDomJs);

var _utilsFnJs = require('../utils/fn.js');

var Fn = _interopRequireWildcard(_utilsFnJs);

var _utilsToTitleCaseJs = require('../utils/to-title-case.js');

var _utilsToTitleCaseJs2 = _interopRequireDefault(_utilsToTitleCaseJs);

/**
 * A button class with a popup control
 *
 * @param {Player|Object} player
 * @param {Object=} options
 * @extends ClickableComponent
 * @class PopupButton
 */

var PopupButton = (function (_ClickableComponent) {
  _inherits(PopupButton, _ClickableComponent);

  function PopupButton(player) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    _classCallCheck(this, PopupButton);

    _ClickableComponent.call(this, player, options);

    this.update();
  }

  /**
   * Update popup
   *
   * @method update
   */

  PopupButton.prototype.update = function update() {
    var popup = this.createPopup();

    if (this.popup) {
      this.removeChild(this.popup);
    }

    this.popup = popup;
    this.addChild(popup);

    if (this.items && this.items.length === 0) {
      this.hide();
    } else if (this.items && this.items.length > 1) {
      this.show();
    }
  };

  /**
   * Create popup - Override with specific functionality for component
   *
   * @return {Popup} The constructed popup
   * @method createPopup
   */

  PopupButton.prototype.createPopup = function createPopup() {};

  /**
   * Create the component's DOM element
   *
   * @return {Element}
   * @method createEl
   */

  PopupButton.prototype.createEl = function createEl() {
    return _ClickableComponent.prototype.createEl.call(this, 'div', {
      className: this.buildCSSClass()
    });
  };

  /**
   * Allow sub components to stack CSS class names
   *
   * @return {String} The constructed class name
   * @method buildCSSClass
   */

  PopupButton.prototype.buildCSSClass = function buildCSSClass() {
    var menuButtonClass = 'vjs-menu-button';

    // If the inline option is passed, we want to use different styles altogether.
    if (this.options_.inline === true) {
      menuButtonClass += '-inline';
    } else {
      menuButtonClass += '-popup';
    }

    return 'vjs-menu-button ' + menuButtonClass + ' ' + _ClickableComponent.prototype.buildCSSClass.call(this);
  };

  /**
   * Return handler for the tooltip
   *
   * @return {Object} Dom element to serve as a handler for the tooltip
   * @method tooltipHandler
   */

  PopupButton.prototype.tooltipHandler = function tooltipHandler() {
    // TODO: Fix popup button to have a real icon element to make it as tooltip handler
    return;
  };

  return PopupButton;
})(_clickableComponentJs2['default']);

_componentJs2['default'].registerComponent('PopupButton', PopupButton);
exports['default'] = PopupButton;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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